import styled from "styled-components";
import { motion } from "framer-motion";

export const ContainerTurnosRecep = styled(motion.div)`
  width: 100%;
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  text-align: center;
  padding-top: 15px;
  padding-bottom: 50px; /* Espacio extra para ver la sombra del último card */
  gap: 15px;
  align-items: center;
`;

export const ContainerCardRecep = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding-top: 10px;
  padding-bottom: 40px;
  align-items: center;
  
  /* Espacio extra al final para ver la sombra del último card */
  &::after {
    content: "";
    display: block;
    height: 20px;
    width: 100%;
    flex-shrink: 0;
  }

  .turnos {
    width: 276px;
    height: 53px;
    border-radius: 8px;
    margin: auto;
    background: var(--color-latex30);
    color: var(--color-white);
    font-weight: 700;
    font-size: 18px;
  }
  .message {
    width: 286px;
    height: 95px;
    margin: auto;
    border: 2px solid var(--color-broccoli);
    color: var(--color-broccoli);
    font-size: 18px;
    border-radius: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    padding: 5px;
  }
`;

export const ContenidoPendiente = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  gap: 20px;
  button {
    width: 300px;
    height: 38px;
    background-color: var(--color-primary);
    border-radius: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 20px;
    color: var(--color-white);
    font-size: 18px;
  }
  span {
    font-weight: 600;
    font-size: 18px;
  }
`;
export const BtnColaVirtual = styled.button`
  width: 216px;
  height: 52px;
  color: white;
  background: var(--color-latex30);
  border-radius: 8px;
`;
